export default "__VITE_ASSET__CPujVApI__"